import React from "react";
import * as Sentry from "@sentry/react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
    Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh", display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center",
          background: "#0a0f1a", color: "#f1f5f9", padding: 24, textAlign: "center",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>⚠️</div>
          <h1 style={{ fontSize: 22, fontWeight: 700, margin: "0 0 8px" }}>Eitthvað fór úrskeiðis</h1>
          <p style={{ fontSize: 14, color: "#94a3b8", margin: "0 0 24px", maxWidth: 320 }}>
            Villa kom upp í appinu. Reyndu að endurhlaða síðuna.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "12px 24px", borderRadius: 12, border: "none",
              background: "linear-gradient(135deg, #38bdf8, #818cf8)",
              color: "#fff", fontSize: 15, fontWeight: 600, cursor: "pointer",
            }}
          >
            Endurhlaða síðu
          </button>
          {this.state.error && (
            <details style={{ marginTop: 24, fontSize: 11, color: "#64748b", maxWidth: 360, textAlign: "left" }}>
              <summary style={{ cursor: "pointer" }}>Tæknilegar upplýsingar</summary>
              <pre style={{ whiteSpace: "pre-wrap", marginTop: 8, padding: 12, background: "#111827", borderRadius: 8, overflow: "auto" }}>
                {this.state.error.toString()}
              </pre>
            </details>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}
